import { render, staticRenderFns } from "./InstallerBio.vue?vue&type=template&id=478a2818&scoped=true&"
import script from "./InstallerBio.vue?vue&type=script&lang=js&"
export * from "./InstallerBio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a2818",
  null
  
)

export default component.exports